<template>
  <div>
    <Card>
      <template #title>Лимит</template>
      <template #content>
        <p><strong>ID: </strong>{{ limit.id }}</p>
        <p><strong>UUID Лимита: </strong>{{ limit.extId }}</p>
        <p><strong>UUID ЦБ: </strong>{{ limit.cbUuid }}</p>
        <Divider></Divider>
        <p v-if="limit.borrowerUuid"><strong>UUID заемщика: </strong>{{ limit.borrowerUuid }}</p>
        <p v-if="limit.appUuid"><strong>UUID заявки: </strong>{{ limit.appUuid }}</p>
        <p v-if="limit.status"><strong>Статус: </strong>{{ limit.status }}</p>
        <Divider></Divider>
        <p><strong>Текущий номер транша: </strong>{{ limit.currentTrancheNum }}</p>
        <p><strong>ID последнего события: </strong>{{ limit.lastEvent }}</p>
        <p><strong>ID последнего успешного события: </strong>{{ limit.lastSuccessEvent }}</p>
        <p v-if="limit.lastEventDate !== null"><strong>Дата посследнего события: </strong>{{ limit.lastEventDate }}</p>
        <Divider></Divider>
        <p><strong>Дата создания: </strong>{{ formatDate(limit.createdAt) }}</p>
        <p><strong>Дата выдачи: </strong>{{ formatDate(limit.startedAt) }}</p>
        <p><strong>Плановая дата окончания: </strong>{{ formatDate(limit.endAt) }}</p>
        <Divider></Divider>
        <p><strong>Причина закрытия: </strong>{{ limit.closeReasonId }}</p>
        <p><strong>Дата закрытия: </strong>{{ formatDate(limit.closedAt) }}</p>
        <Divider></Divider>
      </template>
    </Card>
  </div>
</template>

<script>
import FilterDateService from "@/service/FilterDateService";

export default {
  name: "Limit",
  props: {
    limit: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return FilterDateService.dateToString(date)
    },
  }
}
</script>

<style scoped>

</style>